export default {
  item: {
    type: Object,
    default: () => ({})
  },
  operatorCovenant: {
    type: String,
    default: null
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-professional/components/Items/resources/props.js